'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Transform an array to a map.
 */
const arrayToMap = (array, options) => {
    const { selectKey } = options;
    return array.reduce((acc, current) => {
        const key = selectKey(current);
        const value = options.dataModifier
            ? options.dataModifier(current, acc)
            : current;
        return Object.assign(Object.assign({}, acc), { [key]: value });
    }, {});
};

exports.arrayToMap = arrayToMap;
//# sourceMappingURL=array-to-map.js.map
